import { paginationSchema } from '~/components/Pagination/Pagination.schema';
import { z } from 'zod';

export const querySchema = z
  .object({
    district_id: z
      .string()
      .transform(v => (v ? Number(v) : undefined))
      .optional(),
    club_id: z
      .string()
      .default('')
      .transform(x => (x ? Number(x) : undefined)),
    level: z.enum(['ALL', 'D', 'F', 'K2', 'K1']).default('ALL'),
    club_name: z.string().default(''),
    state: z.enum(['ALL', 'ACTIVE']).default('ACTIVE'),
    search: z.string().default(''),
  })
  .merge(paginationSchema);
